import { UserAttributesClient } from 'frontend-preferences-client';
import { MARKETING_DISCOVERY_UTILS } from '../constants';
const userAttributesClient = UserAttributesClient.forCaller('MarketingDiscoveryUtils');

// UserAttribute always return string values, so we need to typecast the value to the correct type
export const getUserAttribute = (name, defaultValue) => userAttributesClient.fetch(name, defaultValue, MARKETING_DISCOVERY_UTILS);
export const setUserAttribute = (name, value) => userAttributesClient.write(name, value);